import React from 'react';
import { CONF_PLAYER } from '../../../../constants/Labels';
class PlayerSettings extends React.Component {
  constructor(props) {
    super(props);
    this.section = 'player';
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.invalidFileds = [];
    this.controlBarModeList = {
      CONTROL_BAR_MODE_STACKED: 'Stacked',
      CONTROL_BAR_MODE_FLOATING: 'Floating',
    };
    this.scaleModeList = {
      SCALE_MODE_LETTERBOX: 'Letterbox',
      SCALE_MODE_ZOOM: 'Zoom',
      SCALE_MODE_STRETCH: 'Stretch',
    };
  }
  render() {
    return (
      <div className="pluginSettingsSection" id={this.section}>
        <div
          className="placementDescription"
          onClick={e => this.props.toggleElement(e, '.settingsInputs')}
        >
          <div className="pluginSectionsTitle playerTitle">Player Settings</div>
        </div>
        <div className="settingsInputs">
          <div
            className="settingsDescription description"
            dangerouslySetInnerHTML={{ __html: CONF_PLAYER }}
          ></div>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>Enable pause</label>
              </div>
              <div className="smallInput">
                <label>Enable fullscreen</label>
              </div>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.player.enablePause}
                  name="enablePause"
                  id="enablePause0"
                  defaultValue={true}
                  defaultChecked={this.props.player.enablePause === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enablePause0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.player.enablePause}
                  name="enablePause"
                  id="enablePause1"
                  defaultValue={false}
                  defaultChecked={this.props.player.enablePause === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enablePause1">False</label>
              </p>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.player.enableFullscreen}
                  name="enableFullscreen"
                  id="enableFullscreen0"
                  defaultValue={true}
                  defaultChecked={this.props.player.enableFullscreen === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableFullscreen0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.player.enableFullscreen}
                  name="enableFullscreen"
                  id="enableFullscreen1"
                  defaultValue={false}
                  defaultChecked={this.props.player.enableFullscreen === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableFullscreen1">False</label>
              </p>
            </div>
          </div>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>Enable sound</label>
              </div>
              <div className="smallInput">
                <label>Enable countdown video</label>
              </div>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.player.enableSound}
                  name="enableSound"
                  id="enableSound0"
                  defaultValue={true}
                  defaultChecked={this.props.player.enableSound === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableSound0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.player.enableSound}
                  name="enableSound"
                  id="enableSound1"
                  defaultValue={false}
                  defaultChecked={this.props.player.enableSound === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableSound1">False</label>
              </p>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.player.enableCountdownVideo}
                  name="enableCountdownVideo"
                  id="enableCountdownVideo0"
                  defaultValue={true}
                  defaultChecked={this.props.player.enableCountdownVideo === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableCountdownVideo0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.player.enableCountdownVideo}
                  name="enableCountdownVideo"
                  id="enableCountdownVideo1"
                  defaultValue={false}
                  defaultChecked={this.props.player.enableCountdownVideo === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableCountdownVideo1">False</label>
              </p>
            </div>
          </div>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>Enable countdown skip</label>
              </div>
              <div className="smallInput">
                <label>Auto hide controls</label>
              </div>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.player.enableCountdownSkip}
                  name="enableCountdownSkip"
                  id="enableCountdownSkip0"
                  defaultValue={true}
                  defaultChecked={this.props.player.enableCountdownSkip === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableCountdownSkip0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.player.enableCountdownSkip}
                  name="enableCountdownSkip"
                  id="enableCountdownSkip1"
                  defaultValue={false}
                  defaultChecked={this.props.player.enableCountdownSkip === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="enableCountdownSkip1">False</label>
              </p>
            </div>
            <div className="smallInput">
              <p>
                <input
                  type="radio"
                  key={this.props.player.autoHideControls}
                  name="autoHideControls"
                  id="autoHideControls0"
                  defaultValue={true}
                  defaultChecked={this.props.player.autoHideControls === true}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="autoHideControls0">True</label>
              </p>
              <p>
                <input
                  type="radio"
                  key={!this.props.player.autoHideControls}
                  name="autoHideControls"
                  id="autoHideControls1"
                  defaultValue={false}
                  defaultChecked={this.props.player.autoHideControls === false}
                  onClick={e => this.props.handleOptionChange(e, this, Boolean)}
                />
                <label htmlFor="autoHideControls1">False</label>
              </p>
            </div>
          </div>
          <div className="more">
            <div className="inputsRow">
              <div className="labelHolder">
                <div className="smallInput">
                  <label>Scale mode</label>
                </div>
                <div className="smallInput">
                  <label>Controlbar mode</label>
                </div>
              </div>
              <div className="smallInput">
                <select
                  key={this.props.player.scaleMode}
                  className="btnGeneral"
                  name="scaleMode"
                  defaultValue={this.props.player.scaleMode}
                  onChange={e => this.props.handleOptionChange(e, this, String)}
                >
                  {Object.keys(this.scaleModeList).map(item => (
                    <option key={item} value={item}>
                      {this.scaleModeList[item]}
                    </option>
                  ))}
                </select>
                <div className="validationError"></div>
              </div>
              <div className="smallInput">
                <select
                  key={this.props.player.controlBarMode}
                  className="btnGeneral"
                  name="controlBarMode"
                  defaultValue={this.props.player.controlBarMode}
                  onChange={e => this.props.handleOptionChange(e, this, String)}
                >
                  {Object.keys(this.controlBarModeList).map(item => (
                    <option key={item} value={item}>
                      {this.controlBarModeList[item]}
                    </option>
                  ))}
                </select>
                <div className="validationError"></div>
              </div>
            </div>
          </div>
          <div className="moreButtonWrapper">
            <a className="moreButton" onClick={e => this.props.toggleElement(e, '.more')}>
              Show more options <span>▼</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default PlayerSettings;
